{
  "name": "bismillahcss",
  "version": "3.1.2",
  "description": "The next-gen utility-first CSS framework for modern, futuristic web development.",
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "bin": {
    "bismillahcss": "dist/cli.js"
  },
  "exports": {
    ".": {
      "import": "./dist/index.mjs",
      "require": "./dist/index.js",
      "types": "./dist/index.d.ts"
    },
    "./package.json": "./package.json",
    "./bismillah.css": "./dist/bismillah.css",
    "./core/*": "./dist/core/*",
    "./components/*": "./dist/components/*"
  },
  "files": [
    "dist",
    "src",
    "ready-made-components"
  ],
  "scripts": {
    "dev": "tsup --watch",
    "build": "tsup",
    "lint": "tsc --noEmit",
    "clean": "rimraf dist",
    "test": "echo \"Error: no test specified\" && exit 1"
  },
  "keywords": [
    "css",
    "framework",
    "utility-first",
    "futuristic",
    "glassmorphism",
    "neon",
    "bismillah",
    "modern-ui",
    "cli"
  ],
  "author": "Mubashir Ali",
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/BismillahCSS/bismillahcss-framework.git"
  },
  "dependencies": {
    "@babel/core": "^7.23.0",
    "@babel/parser": "^7.23.0",
    "@babel/plugin-transform-typescript": "^7.22.15",
    "@babel/preset-typescript": "^7.23.0",
    "@dotenvx/dotenvx": "^1.0.0",
    "autoprefixer": "^10.4.27",
    "browserslist": "^4.22.1",
    "commander": "^11.1.0",
    "cosmiconfig": "^8.3.6",
    "cssnano": "^6.1.2",
    "dedent": "^1.5.1",
    "deepmerge": "^4.3.1",
    "diff": "^5.1.0",
    "execa": "^8.0.1",
    "fast-glob": "^3.3.3",
    "fs-extra": "^11.3.4",
    "fuzzysort": "^2.0.4",
    "https-proxy-agent": "^7.0.2",
    "kleur": "^4.1.5",
    "msw": "^2.0.1",
    "node-fetch": "^3.3.2",
    "open": "^9.1.0",
    "ora": "^7.0.1",
    "postcss": "^8.4.31",
    "postcss-selector-parser": "^6.0.13",
    "prompts": "^2.4.2",
    "recast": "^0.23.4",
    "stringify-object": "^4.0.1",
    "tailwind-merge": "^1.14.0",
    "ts-morph": "^20.0.0",
    "tsconfig-paths": "^4.2.0",
    "validate-npm-package-name": "^5.0.0",
    "zod": "^3.25.76",
    "zod-to-json-schema": "^3.21.4"
  },
  "devDependencies": {
    "@antfu/ni": "^0.21.8",
    "@types/babel__core": "^7.20.2",
    "@types/fs-extra": "^11.0.2",
    "@types/node": "^20.19.37",
    "@types/prompts": "^2.4.5",
    "@types/stringify-object": "^4.0.2",
    "rimraf": "^5.0.5",
    "tsup": "^7.2.0",
    "type-fest": "^4.4.0",
    "typescript": "^5.9.3"
  }
}